import React from "react";
import "./ProductPreviewShowcase.css";

const SLIDES = [
  {
    id: "dashboard",
    title: "Dashboard financiero",
    desc: "ROI y pulso operativo en tiempo real.",
    mock: "dashboard",
  },
  {
    id: "copilot",
    title: "Copiloto agéntico",
    desc: "Agente financiero con respuestas y acciones. Disponible en planes Growth y Enterprise.",
    mock: "copilot",
  },
  {
    id: "matching",
    title: "Conciliación 3-way",
    desc: "OC → Factura → Remito en un solo flujo.",
    mock: "matching",
  },
  {
    id: "ficha",
    title: "Ficha de comprobante",
    desc: "Extracción IA + validación fiscal ARCA.",
    mock: "ficha",
  },
];

function Mockup({ type, compact = false }) {
  const compactClass = compact ? " ppm-compact" : "";

  if (type === "dashboard") {
    return (
      <div className={`ppm ppm-dashboard${compactClass}`}>
        <div className="ppm-bar">
          <span className="ppm-logo">TagNize</span>
          <span className="ppm-pill">Command Center</span>
        </div>
        <div className="ppm-kpis">
          <div className="ppm-kpi"><strong>128</strong><span>Docs hoy</span></div>
          <div className="ppm-kpi"><strong>94%</strong><span>ARCA OK</span></div>
          <div className="ppm-kpi"><strong>$2.4M</strong><span>Flujo mes</span></div>
        </div>
        <div className="ppm-chart">
          <div className="ppm-chart-bars">
            <span style={{ height: "42%" }} />
            <span style={{ height: "68%" }} />
            <span style={{ height: "55%" }} />
            <span style={{ height: "82%" }} />
            <span style={{ height: "61%" }} />
            <span style={{ height: "90%" }} />
          </div>
        </div>
      </div>
    );
  }

  if (type === "copilot") {
    return (
      <div className={`ppm ppm-copilot${compactClass}`}>
        <div className="ppm-chat-user">¿Cuánto gastamos con proveedores este mes?</div>
        <div className="ppm-chat-bot">
          <strong>Copiloto TagNize</strong>
          <p>Gastaste $1.8M en 47 facturas. Top 3: Logística Sur, Telecom, Energía.</p>
          {!compact && (
            <div className="ppm-chat-actions">
              <span>Ver detalle</span>
              <span>Exportar</span>
            </div>
          )}
        </div>
        {!compact && <div className="ppm-chat-input">Preguntá sobre tus comprobantes…</div>}
      </div>
    );
  }

  if (type === "matching") {
    return (
      <div className={`ppm ppm-matching${compactClass}`}>
        <div className="ppm-flow">
          <div className="ppm-flow-node oc">OC</div>
          <div className="ppm-flow-arrow">→</div>
          <div className="ppm-flow-node inv">Factura</div>
          <div className="ppm-flow-arrow">→</div>
          <div className="ppm-flow-node rem">Remito</div>
        </div>
        {!compact && (
          <div className="ppm-match-rows">
            <div className="ppm-match-row ok"><span>Importe</span><strong>Coincide</strong></div>
            <div className="ppm-match-row ok"><span>CUIT</span><strong>Coincide</strong></div>
            <div className="ppm-match-row warn"><span>Cantidad</span><strong>Revisar</strong></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`ppm ppm-ficha${compactClass}`}>
      <div className="ppm-ficha-doc" />
      <div className="ppm-ficha-panel">
        <span className="ppm-badge-ok">ARCA validado</span>
        <div className="ppm-line" />
        <div className="ppm-line short" />
        {!compact && (
          <>
            <div className="ppm-line" />
            <div className="ppm-ficha-grid">
              <div><small>Emisor</small><strong>Proveedor SA</strong></div>
              <div><small>Total</small><strong>$ 125.400</strong></div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function ProductPreviewShowcase({ slide, onSlideChange }) {
  const current = SLIDES[slide] || SLIDES[0];

  return (
    <section className="pap-showcase" aria-label="Vista previa del producto">
      <div className="pap-showcase-frame">
        <Mockup type={current.mock} />
      </div>
      <div className="pap-showcase-copy">
        <h2>{current.title}</h2>
        <p>{current.desc}</p>
      </div>
      <div className="pap-thumbs" role="tablist">
        {SLIDES.map((item, idx) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={idx === slide}
            aria-label={item.title}
            className={`pap-thumb ${idx === slide ? "active" : ""}`}
            onClick={() => onSlideChange(idx)}
          >
            <span className="pap-thumb-preview" aria-hidden="true">
              <Mockup type={item.mock} compact />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export { SLIDES };
